module.exports = __webpack_public_path__ + "static/media/logo-emblem-white.2097d67f.png";